var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"sac-button-select-container"}},[_vm._l((_vm.sacOptions),function(option,idx){return _c('button',{key:idx,class:[
      'sac-button-select',
      _vm.value === option.value ? 'active' : '',
    ],on:{"click":function($event){return _vm.onSelect(option.value)}}},[_vm._v(" "+_vm._s(option.label)+" ")])}),(_vm.showCustom)?_vm._t("custom"):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }